import { render, staticRenderFns } from "./TransportationLocationSelector.vue?vue&type=template&id=1b383485"
import script from "./TransportationLocationSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransportationLocationSelector.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports